// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Comment Lines, Removed Unused Saga, Payload Destructure
// MODIFIED DATE: 25-09-2025
import { takeLatest, put, all, call } from 'redux-saga/effects';
import ClosedLoanReportActionTypes from './closed-loan-report.types';
import { closedloanDetailsListGet } from './closed-loan-report.service';
import {
	getClosedLoanDetailsDetailsSuccess,
	getClosedLoanDetailsDetailsFailure,
	getClosedLoanDetailsDetailsResponseChanged,
} from './closed-loan-report.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/****************  GET CLOSED LOAN DETAILS LIST START *********************** */
export function* getClosedLoanDetailsList({ payload }: any) {
	try {
		const {
			companyID,
			branchID,
			centerID,
			databaseName,
			fromDate,
			toDate,
			userLevel,
			userID,
			userRole,
			limit,
		} = payload;
		const key = 'GetMemberClosedLoanDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			CenterID: centerID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			UserLevel: userLevel,
			UserID: userID,
			UserRole: userRole,
			Limit: limit,
			DateFilter: 'FromToDate',
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(closedloanDetailsListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getClosedLoanDetailsDetailsFailure(responseData.data));
		} else {
			yield put(getClosedLoanDetailsDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getClosedLoanDetailsDetailsFailure(error));
	}
}

export function* resetGetClosedLoanDetailsListResponse() {
	yield put(getClosedLoanDetailsDetailsResponseChanged());
}

export function* onGetClosedLoanDetailsListDetails() {
	yield takeLatest(
		ClosedLoanReportActionTypes.GET_CLOSED_LOAN_DETAILS_LIST_START,
		getClosedLoanDetailsList,
	);
}

export function* onGetClosedLoanDetailsListResponseReset() {
	yield takeLatest(
		ClosedLoanReportActionTypes.GET_CLOSED_LOAN_DETAILS_LIST_RESPONSE_RESET,
		resetGetClosedLoanDetailsListResponse,
	);
}
/****************  GET CLOSED LOAN DETAILS LIST END *********************** */

export function* reportClosedLoanSaga() {
	yield all([
		call(onGetClosedLoanDetailsListDetails),
		call(onGetClosedLoanDetailsListResponseReset),
	]);
}
